import { configureAmplify } from '../amplify/configureAmplify'

configureAmplify()
